import CAxios from '../../http/requests/cross-checking/index';
import Promise from 'lodash/_Promise';

export default {
    openModal ({ commit }, payload) {
        commit('OPEN_MODAL', payload.open);
        commit('SET_MODAL_ERRORS', {});
        if (payload.open && payload.id) {
            let action = payload.modalType === 'classification'
                ? CAxios.getClassification(payload.id)
                : CAxios.getItem(payload.id);
            action
                .then(response => {
                    commit('SET_MODAL_DATA', response.data.data);
                }).catch(error => {
                commit('OPEN_MODAL', false);
            });
        }
    },
    setData ({ commit }, data) {
        commit('SET_MODAL_DATA', data);
    },

    loadLogs ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            CAxios.getLogs(payload.type)
                .then(response => {
                    commit('SET_LOGS_DATA', response.data.data);
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    },
    getClassifications ({ commit }) {
        return new Promise((resolve, reject) => {
            CAxios.getClassifications()
                .then(response => {

                    commit('SET_CLASSIFICATIONS', response.data.data);
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    },
    getRequestTypes ({ commit }) {
        return new Promise((resolve, reject) => {
            CAxios.getRequestTypes()
                .then(response => {

                    commit('SET_REQUEST_TYPES', response.data.data);
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    },
    getClassification ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            CAxios.getClassification(payload.id)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    },
    getItems ({ commit }) {
        return new Promise((resolve, reject) => {
            CAxios.getItems()
                .then(response => {
                    commit('SET_ITEMS', response.data.data);
                    resolve(response);
                }).catch(error => {
                reject(error);
            });
        });
    },
    openChangelog ({ commit }, value) {
        commit('SET_OPEN_CHANGELOG', value);
    },
    rearrangeItems ({commit}, items) {
        commit('REARRANGE_ITEMS', items);
        CAxios.rearrangeItems(items)
            .then(response => {
                commit('SET_ITEMS', response.data.data);
            })
    },
    rearrangeClassifications ({commit}, items) {
        commit('REARRANGE_CLASSIFICATIONS', items);
        CAxios.rearrangeClassifications(items)
            .then(response => {
                commit('SET_CLASSIFICATIONS', response.data.data);
            })
    },
    createClassification ({
        commit,
        state,
    }, payload) {
        let data = JSON.parse(JSON.stringify(payload.classification));
        return new Promise((resolve, reject) => {
            data.priority = state.classifications.length + 1;
            CAxios.createClassification(data)
                .then(response => {
                    commit('SET_MODAL_ERRORS', {});
                    commit('SET_MODAL_DATA', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        commit('SET_MODAL_ERRORS', error.response.data.data);
                    }
                    reject(error);
                });
        });
    },
    createItem ({
        commit,
        state,
    }, payload) {
        let data = JSON.parse(JSON.stringify(payload.item));
        return new Promise((resolve, reject) => {
            data.priority = state.items.length + 1;
            CAxios.createItem(data)
                .then(response => {
                    commit('SET_MODAL_ERRORS', {});
                    commit('SET_MODAL_DATA', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        commit('SET_MODAL_ERRORS', error.response.data.data);
                    }
                    reject(error);
                });
        });
    },
    updateClassification ({
        commit,
        state,
    }, payload) {
        let data = JSON.parse(JSON.stringify(payload.classification));
        return new Promise((resolve, reject) => {
            CAxios.updateClassification(payload.id, data)
                .then(response => {
                    commit('SET_MODAL_ERRORS', {});
                    commit('SET_MODAL_DATA', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        commit('SET_MODAL_ERRORS', error.response.data.data);
                    }
                    reject(error);
                });
        });
    },
    updateItem ({
        commit,
        state,
    }, payload) {
        let data = JSON.parse(JSON.stringify(payload.item));
        return new Promise((resolve, reject) => {
            CAxios.updateItem(payload.id, data)
                .then(response => {
                    commit('SET_MODAL_ERRORS', {});
                    commit('SET_MODAL_DATA', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        commit('SET_MODAL_ERRORS', error.response.data.data);
                    }
                    reject(error);
                });
        });
    },
    removeClassification ({
        commit,
        state,
    }, payload) {
        return new Promise((resolve, reject) => {
            CAxios.removeClassification(payload.id)
                .then(response => {
                    commit('SET_MODAL_ERRORS', {});
                    commit('SET_MODAL_DATA', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        commit('SET_MODAL_ERRORS', error.response.data.data);
                    }
                    reject(error);
                });
        });
    },
    removeItem ({
        commit,
        state,
    }, payload) {
        return new Promise((resolve, reject) => {
            CAxios.removeItem(payload.id)
                .then(response => {
                    commit('SET_MODAL_ERRORS', {});
                    commit('SET_MODAL_DATA', response.data.data);
                    resolve(response);
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        commit('SET_MODAL_ERRORS', error.response.data.data);
                    }
                    reject(error);
                });
        });
    },
};
